import { ApiRuntime } from '@core/swagger-client';
import { createIsomorphicFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

// The server renders many requests at once, each with its own runtime; the one for "now" is found
// through the request Start is handling (getRequest reads Start's own request context, the same one
// getCookie uses). One H3 event, and so one Request object, exists per request. The browser has
// exactly one runtime. Only log lines read this (see swagger-client's currentRuntime.ts).
const serverRuntimes = new WeakMap<Request, ApiRuntime>();
let browserRuntime: ApiRuntime | undefined;

export const rememberRuntime = createIsomorphicFn()
    .server((runtime: ApiRuntime) => {
        serverRuntimes.set(getRequest(), runtime);
    })
    .client((runtime: ApiRuntime) => {
        browserRuntime = runtime;
    });

export const findRuntime = createIsomorphicFn()
    .server((): ApiRuntime | undefined => serverRuntimes.get(getRequest()))
    .client((): ApiRuntime | undefined => browserRuntime);
